const LEGACY_CODES = {
    'Invalid login or password': 'invalid_login_or_password',
    'Passwords do not match': 'passwords_do_not_match',
    'Login already taken': 'login_already_taken',
    'Captcha token required': 'captcha_token_required',
    'Captcha verification failed': 'captcha_verification_failed',
    'Captcha not configured': 'captcha_not_configured',
};

export const AUTH_MESSAGE_KEYS = {
    invalid_login_or_password: 'Неверный логин или пароль',
    passwords_do_not_match: 'Пароли не совпадают',
    login_already_taken: 'Логин уже занят',
    captcha_token_required: 'Подтвердите, что вы не робот',
    captcha_verification_failed: 'Не удалось пройти проверку капчи',
    captcha_not_configured: 'Капча не настроена',
    registration_failed: 'Не удалось зарегистрироваться',
    login_failed: 'Не удалось войти',
};

export const extractAuthDetail = (detail) => {
    if (Array.isArray(detail)) {
        return detail.map((item) => item?.msg || item).join(', ');
    }
    return typeof detail === 'string' ? detail : '';
};

export const normalizeAuthErrorCode = (detail) => {
    const raw = extractAuthDetail(detail);
    if (!raw) {
        return null;
    }
    return LEGACY_CODES[raw] || raw;
};

export const getAuthFieldErrors = (code) => {
    switch (code) {
        case 'invalid_login_or_password':
            return { login: true, password: true };
        case 'login_already_taken':
            return { login: true };
        case 'passwords_do_not_match':
            return { password: true, passwordConfirm: true };
        default:
            return {};
    }
};

export const parseAuthApiError = (detail, t, fallbackCode = 'login_failed') => {
    const code = normalizeAuthErrorCode(detail) || fallbackCode;
    const messageKey = AUTH_MESSAGE_KEYS[code];
    const message = messageKey ? t(messageKey) : extractAuthDetail(detail) || t(AUTH_MESSAGE_KEYS[fallbackCode]);

    return {
        code,
        message,
        fields: getAuthFieldErrors(code),
    };
};
